import SlideInDown from './slide-in-down'
import SlideInUp from './slide-in-up'
import SlideInLeft from './slide-in-left'
import SlideInRight from './slide-in-right'

export default {
  SlideInDown,
  SlideInLeft,
  SlideInRight,
  SlideInUp
}



// WEBPACK FOOTER //
// ./src/animates/animated-vue/transitions/sliding-entrances/index.js